import webStorageManager from "../managers/web-storage";
import { STORAGE_KEY_USER_INFO } from "../managers/constants";

const service = (() => {
  // Get logged in user's ID
  const getUserId = () => {
    let userInfo = webStorageManager.get(STORAGE_KEY_USER_INFO);
    return userInfo && typeof userInfo === "object" ? userInfo.userId : "";
  };

  // Get logged in user's name
  const getUserName = () => {
    let userInfo = webStorageManager.get(STORAGE_KEY_USER_INFO);
    return userInfo && typeof userInfo === "object" ? userInfo.userName : "";
  };

  return { getUserId, getUserName };
})();

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/app.js